import FileUpload from '@cob/ui-genesis/helpers/cob.file-upload.js'
import RecordmImporterStatsP from './recordm.importer.presenter.stats.js'
import {sprintf} from "sprintf-js"
import tmpl_file_upload from '../templates/recordm-importer-upload-dialog.dot'

const RecordmImporterP = function(core, definitionName, importerName, customImportMsg) {
    let abortUri;

    const _stop = function() {
        statsP.stop();
        fuP.stop();
    };

    const fupCbs = {
        uploadSuccessful: function(fileName, response) {
            const json = JSON.parse(response.result);
            const importId = json.import_id;
            const abortable = json.abortable;

            fuP.hideUploadForm();
            fuP.hideUploadBtn();
            statsP.start(fuP.getContainer(), fileName, importId, abortable ? abortUri : undefined);
        },
        cancel:_stop
    };

    const fupOpts = {
        timeout: 5 * 60 * 1000, // 5min timeout, for slower connections
        allowedFileExtensions: ["xls", "xlsx"],
        closeOnSuccess: false,
        closeOnFail: false,
        tmpl: tmpl_file_upload,
        importerName: importerName,
        customImportMsg: customImportMsg
    };

    if(definitionName){
        fupOpts.dialogTitle = sprintf(core.translateString("recordm.search", "import.dialog-title"), definitionName);
    }

    const fuP = new FileUpload.UploadFileP(core, fupCbs, fupOpts);

    const statsP = new RecordmImporterStatsP(core, {});

    return{
        start: function(url) {
            abortUri = url.replace(/file\?def=.*/, "import");
            fuP.start(url);
        },
        stop: _stop
    };
};

export default RecordmImporterP;

